export default __webpack_public_path__ + "sounds/framework/11twinklealert_R.6961b9f1.mp3?6961b9f1";